import { useEffect, useState } from "react";

import { useFetchQuotationContext } from "context/QuotationListContext";
import { Link } from "react-router-dom";

const AdminQuotationList = () => {
  const { getQuotations, loading, quotations, deleteQuotation } =
    useFetchQuotationContext();

  useEffect(() => {
    getQuotations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [sortField, setSortField] = useState("date");
  const [sortDirection, setSortDirection] = useState("desc");

  const handleSort = (field: string) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const handleDelete = async (id: string, name: string, email: string) => {
    await deleteQuotation(id, name, email);
  };

  const sortedLinks = [...quotations].sort((a, b) => {
    const aValue = a[sortField as keyof typeof a];
    const bValue = b[sortField as keyof typeof b];

    if (aValue && bValue) {
      if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
    }
    return 0;
  });

  const sortIndicator = (field: string) => {
    if (sortField !== field) return "";
    return sortDirection === "asc" ? " \u2191" : " \u2193";
  };

  return (
    <div>
      <div className="admin-page-header">
        <div className="admin-page-header__left">
          <h1>Quotations</h1>
          {!loading && (
            <span className="admin-badge">{quotations.length}</span>
          )}
        </div>
        <button onClick={() => getQuotations(true)}>Refresh</button>
      </div>

      {loading && (
        <div className="admin-empty-state">
          <p>Loading quotations...</p>
        </div>
      )}

      {!loading && quotations.length === 0 && (
        <div className="admin-empty-state">
          <p>No quotations found.</p>
        </div>
      )}

      {!loading && quotations.length > 0 && (
        <div className="admin-table-wrap">
          <table className="quotation-table">
            <thead>
              <tr>
                <th onClick={() => handleSort("name")} style={{ cursor: "pointer" }}>
                  Name{sortIndicator("name")}
                </th>
                <th onClick={() => handleSort("email")} style={{ cursor: "pointer" }}>
                  Email{sortIndicator("email")}
                </th>
                <th onClick={() => handleSort("date")} style={{ cursor: "pointer" }}>
                  Date{sortIndicator("date")}
                </th>
                <th onClick={() => handleSort("createdBy")} style={{ cursor: "pointer" }}>
                  Created By{sortIndicator("createdBy")}
                </th>
                <th onClick={() => handleSort("province")} style={{ cursor: "pointer" }}>
                  Province{sortIndicator("province")}
                </th>
                <th>Notes</th>
                <th style={{ width: 80 }} />
              </tr>
            </thead>
            <tbody>
              {sortedLinks.map((link) => (
                <tr key={link.id}>
                  <td>
                    <Link to={`/admin/quotations/${link.id}`}>
                      {link.name || "No name"}
                    </Link>
                  </td>
                  <td>{link.email}</td>
                  <td>{new Date(link.date.seconds * 1000).toLocaleDateString()}</td>
                  <td>{link.createdBy}</td>
                  <td>
                    <span className="admin-province-badge">
                      {link.province}
                    </span>
                  </td>
                  <td className="admin-cell-truncate">{link.note}</td>
                  <td>
                    <button
                      className="btn-destructive"
                      onClick={() => handleDelete(link.id, link.name, link.email)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminQuotationList;
